export interface MangaChapter {
  id: string;
  title: string;
  views: string;
  updateTime: string;
}

export interface Manga {
  id: string;
  title: string;
  author: string;
  categoryId: string;
  categoryName: string;
  tags: string[];
  cover: string;
  description: string;
  status: "连载中" | "已完结";
  rating: number;
  viewers: string;
  chapterCount: number;
  latestChapter: string;
  updateTime: string;
  intensity: number;
  isHot: boolean;
  isNew: boolean;
  isEditorPick: boolean;
  heroLine: string;
  themes: string[];
  chapters: MangaChapter[];
}

export const mangaList: Manga[] = [
  {
    id: "xiari-chuwei",
    title: "夏日初吻日记",
    author: "桃桃酱",
    categoryId: "chuntian",
    categoryName: "纯爱甜宠",
    tags: ["甜宠", "校园", "双向奔赴"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20blushing%20boy%20and%20girl%20sharing%20their%20first%20kiss%20under%20pink%20cherry%20blossoms%20in%20summer%2C%20warm%20sunlight%20flares%2C%20sweet%20romantic%20atmosphere%2C%20clean%20vibrant%20illustration%20style%2C%20soft%20peach%20palette&width=600&height=800&seq=manga-chuwei-01&orientation=portrait",
    description:
      "高二转学生林夏与话少却温柔的班长顾言，在一次校庆排练中被迫搭档。从最初的生疏到眼神交汇时的心跳漏拍，盛夏的每一帧都染上了淡淡的粉色。纯爱甜宠无虐点，双向奔赴的高糖恋爱慢慢升温。",
    status: "连载中",
    rating: 9.6,
    viewers: "328.4万",
    chapterCount: 86,
    latestChapter: "第86话 泳池边的失控",
    updateTime: "2小时前",
    intensity: 92,
    isHot: true,
    isNew: true,
    isEditorPick: true,
    heroLine: "初吻不是计划好的，是心动先走了一步。",
    themes: ["双向奔赴", "脸红瞬间", "甜宠日常"],
    chapters: [
      { id: "c86", title: "第86话 泳池边的失控", views: "18.2万", updateTime: "2小时前" },
      { id: "c85", title: "第85话 心跳实验", views: "21.6万", updateTime: "昨天" },
      { id: "c84", title: "第84话 交换日记", views: "19.4万", updateTime: "3天前" },
      { id: "c83", title: "第83话 校庆夜的烟火", views: "24.1万", updateTime: "5天前" },
      { id: "c82", title: "第82话 说不出口的喜欢", views: "22.8万", updateTime: "1周前" },
    ],
  },
  {
    id: "gebizhuo-anhao",
    title: "隔壁桌的暗号",
    author: "蜜桃果冻",
    categoryId: "anlian",
    categoryName: "暗恋心事",
    tags: ["暗恋", "校园", "纸条"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20shy%20schoolgirl%20secretly%20passing%20a%20folded%20note%20across%20desks%2C%20blushing%2C%20soft%20classroom%20sunlight%2C%20warm%20pastel%20cream%20and%20pink%20tone%2C%20gentle%20romantic%20illustration%20style&width=600&height=800&seq=manga-anhao-01&orientation=portrait",
    description:
      "暗恋同桌周曜一整年的许眠，用一沓折成小飞机的纸条，小心翼翼又笨拙地靠近他。每一次对视都像被看穿心事，心跳声大到快要淹没课堂。暗恋心事与小心翼翼的心动，甜到让人脸红。",
    status: "连载中",
    rating: 9.4,
    viewers: "251.9万",
    chapterCount: 64,
    latestChapter: "第64话 纸条上的句号",
    updateTime: "5小时前",
    intensity: 88,
    isHot: true,
    isNew: false,
    isEditorPick: true,
    heroLine: "暗恋是一场漫长的告白，而我准备了整整三年。",
    themes: ["暗恋心事", "纸条传情", "害羞脸红"],
    chapters: [
      { id: "c64", title: "第64话 纸条上的句号", views: "14.3万", updateTime: "5小时前" },
      { id: "c63", title: "第63话 转校生的秘密", views: "16.8万", updateTime: "2天前" },
      { id: "c62", title: "第62话 座位下的惊喜", views: "15.1万", updateTime: "4天前" },
      { id: "c61", title: "第61话 运动会的心跳", views: "17.9万", updateTime: "6天前" },
    ],
  },
  {
    id: "sudi-yuanxin",
    title: "宿敌与甜心",
    author: "桃桃泡泡",
    categoryId: "yuanjia",
    categoryName: "冤家拉扯",
    tags: ["欢喜冤家", "拉扯", "高能"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20teasing%20boy%20leaning%20in%20while%20a%20flustered%20girl%20turns%20away%20blushing%2C%20playful%20banter%2C%20warm%20coral%20and%20rose%20tone%2C%20electric%20romantic%20tension%2C%20clean%20vibrant%20illustration%20style&width=600&height=800&seq=manga-yuanxin-01&orientation=portrait",
    description:
      "从小到大吵到大的冤家沈叙与苏糖，因为一次校园竞标赛被分到同组。嘴上互怼不断，眼神却越来越黏。针锋相对的拉扯里藏着说不清道不明的占有欲，脸红与心动高能并存。",
    status: "已完结",
    rating: 9.5,
    viewers: "402.1万",
    chapterCount: 120,
    latestChapter: "第120话 终章·宿敌的告白",
    updateTime: "完结",
    intensity: 90,
    isHot: true,
    isNew: false,
    isEditorPick: true,
    heroLine: "全世界都知道我喜欢你，只有你以为我在抬杠。",
    themes: ["欢喜冤家", "占有欲", "拉扯高能"],
    chapters: [
      { id: "c120", title: "第120话 终章·宿敌的告白", views: "38.7万", updateTime: "完结" },
      { id: "c119", title: "第119话 吃醋现场", views: "30.2万", updateTime: "完结" },
      { id: "c118", title: "第118话 情书风波", views: "29.4万", updateTime: "完结" },
      { id: "c117", title: "第117话 天台摊牌", views: "28.1万", updateTime: "完结" },
    ],
  },
  {
    id: "yizhi-hunyue",
    title: "一纸婚约",
    author: "桃桃漫研社",
    categoryId: "qiyue",
    categoryName: "契约恋爱",
    tags: ["契约", "先婚后爱", "甜虐"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20stylish%20couple%20signing%20a%20contract%20with%20elegant%20fountain%20pen%2C%20warm%20golden%20and%20peach%20light%2C%20refined%20modern%20romantic%20illustration%2C%20elegant%20clean%20composition&width=600&height=800&seq=manga-hunyue-01&orientation=portrait",
    description:
      "为帮家里渡过难关，设计师姜宁与冷面总裁陆之航签订了一纸为期一年的婚约契约。说好各取所需、互不越界，却在一顿顿饭、一次次被护住的瞬间里，让界限一点点崩塌。契约恋爱假戏真做，甜虐拉扯太上头。",
    status: "连载中",
    rating: 9.3,
    viewers: "286.5万",
    chapterCount: 72,
    latestChapter: "第72话 违约条款",
    updateTime: "8小时前",
    intensity: 85,
    isHot: false,
    isNew: true,
    isEditorPick: true,
    heroLine: "婚约是一纸合同，心动却从不守约。",
    themes: ["先婚后爱", "假戏真做", "界限崩塌"],
    chapters: [
      { id: "c72", title: "第72话 违约条款", views: "16.5万", updateTime: "8小时前" },
      { id: "c71", title: "第71话 屋檐下的同居", views: "18.9万", updateTime: "1天前" },
      { id: "c70", title: "第70话 结婚证上的照片", views: "17.2万", updateTime: "3天前" },
      { id: "c69", title: "第69话 契约第一条", views: "15.8万", updateTime: "5天前" },
    ],
  },
  {
    id: "bangongshi-xintiao",
    title: "办公室心跳",
    author: "桃桃不加糖",
    categoryId: "zhichang",
    categoryName: "职场暧昧",
    tags: ["职场", "年上", "克制"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20mature%20office%20couple%20in%20business%20attire%20almost%20touching%20at%20a%20modern%20desk%2C%20warm%20amber%20evening%20office%20lighting%2C%20suppressed%20romantic%20tension%2C%20clean%20stylish%20illustration%20style&width=600&height=800&seq=manga-xintiao-01&orientation=portrait",
    description:
      "初入职场的新人程雨，和冷静克制的顶头上司许临风成了并肩作战的搭档。加班的深夜、递咖啡时相触的指尖、若即若离的试探，职场暧昧在克制与汹涌之间反复拉扯。",
    status: "连载中",
    rating: 9.2,
    viewers: "197.8万",
    chapterCount: 58,
    latestChapter: "第58话 深夜加班",
    updateTime: "1天前",
    intensity: 82,
    isHot: false,
    isNew: true,
    isEditorPick: false,
    heroLine: "工作之外的心动，都是偷偷加班的理由。",
    themes: ["职场暧昧", "年上克制", "并肩作战"],
    chapters: [
      { id: "c58", title: "第58话 深夜加班", views: "12.6万", updateTime: "1天前" },
      { id: "c57", title: "第57话 递咖啡的手", views: "14.1万", updateTime: "3天前" },
      { id: "c56", title: "第56话 并肩的灯光", views: "13.4万", updateTime: "5天前" },
    ],
  },
  {
    id: "tiantai-xinshi",
    title: "天台心事",
    author: "桃桃同学",
    categoryId: "xiaoyuan",
    categoryName: "校园心动",
    tags: ["校园", "告白", "青春"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20two%20high%20school%20students%20on%20a%20rooftop%20watching%20a%20sunset%2C%20warm%20golden%20and%20peach%20sky%2C%20gentle%20youthful%20romance%2C%20clean%20vibrant%20illustration%20style&width=600&height=800&seq=manga-tiantai-01&orientation=portrait",
    description:
      "天台是全校最安静的地方，也是林然和江晚交换心事的小天地。考试、社团、毕业的焦虑都被风带走，只留下夕阳下越靠越近的两个影子。校园心动，青涩又纯粹。",
    status: "已完结",
    rating: 9.1,
    viewers: "154.3万",
    chapterCount: 45,
    latestChapter: "第45话 毕业前的告白",
    updateTime: "完结",
    intensity: 79,
    isHot: false,
    isNew: false,
    isEditorPick: false,
    heroLine: "心事说给风听，喜欢说给你听。",
    themes: ["校园心动", "夕阳告白", "青涩青春"],
    chapters: [
      { id: "c45", title: "第45话 毕业前的告白", views: "20.3万", updateTime: "完结" },
      { id: "c44", title: "第44话 天台上的许愿", views: "16.9万", updateTime: "完结" },
      { id: "c43", title: "第43话 交换心事", views: "15.2万", updateTime: "完结" },
    ],
  },
  {
    id: "zhuanxue-tongzhuo",
    title: "转学后的同桌",
    author: "蜜桃果冻",
    categoryId: "anlian",
    categoryName: "暗恋心事",
    tags: ["暗恋", "转学", "校园"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20new%20transfer%20student%20sitting%20next%20to%20a%20curious%20classmate%20in%20classroom%2C%20soft%20warm%20light%2C%20gentle%20romantic%20illustration%20style%2C%20pastel%20cream%20and%20pink%20tone&width=600&height=800&seq=manga-tongzhuo-01&orientation=portrait",
    description:
      "转学到陌生城市的陈默，成了同桌苏禾唯一愿意主动说话的人。从递一块橡皮到共享一副耳机，暗恋在小细节里悄悄发芽。新环境里的双向靠近，安静又动人。",
    status: "连载中",
    rating: 8.9,
    viewers: "98.6万",
    chapterCount: 36,
    latestChapter: "第36话 耳机分你一半",
    updateTime: "2天前",
    intensity: 76,
    isHot: false,
    isNew: true,
    isEditorPick: false,
    heroLine: "新城市很陌生，但你很熟悉。",
    themes: ["暗恋心事", "转学", "小细节"],
    chapters: [
      { id: "c36", title: "第36话 耳机分你一半", views: "9.8万", updateTime: "2天前" },
      { id: "c35", title: "第35话 一块橡皮的距离", views: "10.4万", updateTime: "4天前" },
      { id: "c34", title: "第34话 同桌的试探", views: "9.2万", updateTime: "6天前" },
    ],
  },
  {
    id: "beipo-yingye",
    title: "被迫营业的恋爱",
    author: "桃桃漫研社",
    categoryId: "qiyue",
    categoryName: "契约恋爱",
    tags: ["契约", "搞笑", "假恋爱"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20reluctant%20couple%20posing%20awkwardly%20with%20a%20cheeky%20expressions%2C%20playful%20contract%20love%20trope%2C%20warm%20peach%20and%20cream%20tone%2C%20fun%20vibrant%20illustration%20style&width=600&height=800&seq=manga-yingye-01&orientation=portrait",
    description:
      "为应付家里安排的相亲，嘴硬的程序员徐一一和元气女主播顾野达成了一个月的「假恋爱」协议。明明说好只是营业，却在一次次被迫牵手、被迫约会里，把心也一起赔了进去。",
    status: "连载中",
    rating: 8.8,
    viewers: "176.2万",
    chapterCount: 49,
    latestChapter: "第49话 营业结束那天",
    updateTime: "6小时前",
    intensity: 74,
    isHot: false,
    isNew: true,
    isEditorPick: false,
    heroLine: "这段恋爱是假的，但心动是真的。",
    themes: ["假恋爱", "契约", "搞笑甜"],
    chapters: [
      { id: "c49", title: "第49话 营业结束那天", views: "13.7万", updateTime: "6小时前" },
      { id: "c48", title: "第48话 被迫约会", views: "14.9万", updateTime: "2天前" },
      { id: "c47", title: "第47话 假恋爱的日常", views: "12.5万", updateTime: "4天前" },
    ],
  },
  {
    id: "qianren-xinlinju",
    title: "前任的新邻居",
    author: "桃桃不加糖",
    categoryId: "yuanjia",
    categoryName: "冤家拉扯",
    tags: ["前任", "邻里", "破镜重圆"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20two%20adults%20meeting%20awkwardly%20at%20an%20apartment%20door%20with%20moving%20boxes%2C%20warm%20evening%20apartment%20light%2C%20rekindled%20romantic%20tension%2C%20clean%20stylish%20illustration%20style&width=600&height=800&seq=manga-xinlinju-01&orientation=portrait",
    description:
      "分手三年的前任，居然搬到了自己隔壁。从刻意回避到走廊偶遇时的心跳漏拍，破镜重圆的拉扯里带着成年人的克制与不甘。前任与新邻居的双重身份，让每一次照面都火花四溅。",
    status: "已完结",
    rating: 8.7,
    viewers: "143.9万",
    chapterCount: 52,
    latestChapter: "第52话 终章·重新开始",
    updateTime: "完结",
    intensity: 72,
    isHot: false,
    isNew: false,
    isEditorPick: false,
    heroLine: "我们重新认识一下吧，从邻居开始。",
    themes: ["破镜重圆", "前任", "成年拉扯"],
    chapters: [
      { id: "c52", title: "第52话 终章·重新开始", views: "17.6万", updateTime: "完结" },
      { id: "c51", title: "第51话 走廊的心跳", views: "15.3万", updateTime: "完结" },
      { id: "c50", title: "第50话 新邻居", views: "14.8万", updateTime: "完结" },
    ],
  },
  {
    id: "shenye-kafeishi",
    title: "深夜咖啡师",
    author: "桃桃同学",
    categoryId: "zhichang",
    categoryName: "职场暧昧",
    tags: ["咖啡", "治愈", "微甜"],
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20warm%20barista%20and%20a%20regular%20customer%20in%20a%20cozy%20night%20cafe%2C%20soft%20warm%20glow%2C%20gentle%20romantic%20atmosphere%2C%20clean%20vibrant%20illustration%20style%2C%20peach%20and%20cream%20palette&width=600&height=800&seq=manga-kafeishi-01&orientation=portrait",
    description:
      "深夜咖啡店营业到凌晨，值夜班的咖啡师沈迟，成了加班女孩晚晚唯一的熟悉。一杯特调、一句晚安，微甜的职场暧昧在氤氲的咖啡香气里慢慢升温。",
    status: "连载中",
    rating: 8.6,
    viewers: "121.5万",
    chapterCount: 41,
    latestChapter: "第41话 晚安特调",
    updateTime: "3天前",
    intensity: 70,
    isHot: false,
    isNew: false,
    isEditorPick: false,
    heroLine: "深夜的咖啡是苦的，遇见你是甜的。",
    themes: ["治愈微甜", "深夜", "咖啡"],
    chapters: [
      { id: "c41", title: "第41话 晚安特调", views: "11.2万", updateTime: "3天前" },
      { id: "c40", title: "第40话 熟悉的味道", views: "12.8万", updateTime: "5天前" },
      { id: "c39", title: "第39话 常客", views: "10.9万", updateTime: "1周前" },
    ],
  },
];

export const heroHighlights = [
  {
    id: "xiari-chuwei",
    title: "夏日初吻日记",
    categoryName: "纯爱甜宠",
    heroLine: "初吻不是计划好的，是心动先走了一步。",
    latestChapter: "第86话 泳池边的失控",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20blushing%20boy%20and%20girl%20sharing%20their%20first%20kiss%20under%20pink%20cherry%20blossoms%20in%20summer%2C%20warm%20sunlight%20flares%2C%20sweet%20romantic%20atmosphere%2C%20clean%20vibrant%20illustration%20style%2C%20soft%20peach%20palette&width=900&height=1200&seq=manga-chuwei-hero-01&orientation=portrait",
  },
  {
    id: "sudi-yuanxin",
    title: "宿敌与甜心",
    categoryName: "冤家拉扯",
    heroLine: "全世界都知道我喜欢你，只有你以为我在抬杠。",
    latestChapter: "第120话 终章·宿敌的告白",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20teasing%20boy%20leaning%20in%20while%20a%20flustered%20girl%20turns%20away%20blushing%2C%20playful%20banter%2C%20warm%20coral%20and%20rose%20tone%2C%20electric%20romantic%20tension%2C%20clean%20vibrant%20illustration%20style&width=900&height=1200&seq=manga-sudi-hero-01&orientation=portrait",
  },
  {
    id: "yizhi-hunyue",
    title: "一纸婚约",
    categoryName: "契约恋爱",
    heroLine: "婚约是一纸合同，心动却从不守约。",
    latestChapter: "第72话 违约条款",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20stylish%20couple%20signing%20a%20contract%20with%20elegant%20fountain%20pen%2C%20warm%20golden%20and%20peach%20light%2C%20refined%20modern%20romantic%20illustration%2C%20elegant%20clean%20composition&width=900&height=1200&seq=manga-hunyue-hero-01&orientation=portrait",
  },
];